<template>
	<Modal v-model="show" :closeOnMask="false" :width="560">
		<div slot="header"><i class="fa fa-book"></i> 电子账簿</div>
		<Form label-position="left" :label-width="100">
			<FormItem label="账簿期间" required>
				<Row type="flex" :space-x="10">
					<Cell :flex="1">
						<DatePicker type="month" v-model="periodStart" format="YYYY-MM" placeholder="开始期间"/>
					</Cell>
					<Cell>至</Cell>
					<Cell :flex="1">
						<DatePicker type="month" v-model="periodEnd" format="YYYY-MM" placeholder="结束期间"/>
					</Cell>
				</Row>
			</FormItem>
			<FormItem label="纸张版式">
				<Select v-model="paper" :datas="papers" keyName="key" titleName="label"/>
			</FormItem>
			<FormItem label="装订留白">
				<Radio v-model="bindMode" :datas="bindModes" keyName="key" titleName="label"/>
			</FormItem>
			<FormItem label="装订信息">
				<Row type="flex" :space-x="10">
					<Cell :flex="1"><input type="text" class="h-input" v-model="printBy.manager" placeholder="财务主管"/></Cell>
					<Cell :flex="1"><input type="text" class="h-input" v-model="printBy.bookkeeper" placeholder="会计"/></Cell>
				</Row>
				<Row type="flex" :space-x="10" class="margin-top">
					<Cell :flex="1"><input type="text" class="h-input" v-model="printBy.auditor" placeholder="审核"/></Cell>
					<Cell :flex="1"><input type="text" class="h-input" v-model="printBy.cashier" placeholder="出纳"/></Cell>
				</Row>
			</FormItem>
		</Form>
		<p class="dark4-color" style="font-size:12px;">导出后系统将自动附加数字签名并留存存证，可通过「电子账簿防篡改核验」验证文件完整性。</p>
		<div slot="footer">
			<Button @click="show = false">取消</Button>
			<Button color="primary" :loading="exporting" @click="doExport">导出并签名</Button>
		</div>
	</Modal>
</template>

<script>
	import moment from 'moment'

	export default {
		name: "ElectronicBook",
		props: {
			value: {type: Boolean, default: false},
			accountDate: {type: [String, Date], default: null}
		},
		data() {
			return {
				papers: [
					{key: 'invoice', label: '发票版 24×14cm（推荐）'},
					{key: 'a4', label: 'A4整版'},
					{key: 'a4half', label: 'A4两版（推荐）'},
					{key: 'a4wide', label: 'A4宽 21×12cm（横向）'},
					{key: 'a5', label: 'A5（横向）'},
					{key: 'b5', label: 'B5（横向）'}
				],
				bindModes: [
					{key: 'duplex', label: '双面打印（留白左右交替）'},
					{key: 'simplex', label: '单面打印（留白统一左侧）'},
					{key: 'none', label: '不打印（仅存档）'}
				],
				periodStart: null,
				periodEnd: null,
				paper: 'invoice',
				bindMode: 'duplex',
				printBy: {manager: '', bookkeeper: '', auditor: '', cashier: ''},
				exporting: false
			};
		},
		computed: {
			show: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit('input', val);
				}
			}
		},
		watch: {
			value(val) {
				if (val && !this.periodStart) {
					let base = this.accountDate ? moment(this.accountDate) : moment();
					this.periodStart = base.format('YYYY-MM');
					this.periodEnd = base.format('YYYY-MM');
				}
			}
		},
		methods: {
			doExport() {
				if (!this.periodStart || !this.periodEnd) {
					this.$Message("请选择账簿期间");
					return;
				}
				if (this.periodStart > this.periodEnd) {
					this.$Message("开始期间不能大于结束期间");
					return;
				}
				let fd = new FormData();
				fd.append('periodStart', this.periodStart);
				fd.append('periodEnd', this.periodEnd);
				fd.append('paper', this.paper);
				fd.append('bindMode', this.bindMode);
				Object.keys(this.printBy).forEach(key => {
					if (this.printBy[key]) {
						fd.append(key, this.printBy[key]);
					}
				});
				this.exporting = true;
				this.$api.voucher.bookSignExport(fd).then(res => {
					this.saveBlob(res);
					this.$Message("电子账簿导出成功");
					this.show = false;
				}).catch(err => {
					this.handleError(err);
				}).finally(() => {
					this.exporting = false;
				});
			},
			saveBlob(res) {
				let fileName = '电子账簿-已签名.pdf';
				let disposition = res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition']);
				if (disposition) {
					let match = disposition.match(/filename\*?=(?:UTF-8'')?([^;]+)/i);
					if (match) {
						try {
							fileName = decodeURIComponent(match[1].replace(/"/g, '').trim());
						} catch (e) {
							fileName = match[1].replace(/"/g, '').trim();
						}
					}
				}
				let blob = new Blob([res.data], {type: 'application/pdf'});
				let a = document.createElement('a');
				a.href = URL.createObjectURL(blob);
				a.download = fileName;
				a.click();
				URL.revokeObjectURL(a.href);
			},
			handleError(err) {
				let data = err.response && err.response.data;
				if (data instanceof Blob) {
					let reader = new FileReader();
					reader.onload = () => {
						try {
							let json = JSON.parse(reader.result);
							this.$Message.error(json.msg || "导出失败");
						} catch (e) {
							this.$Message.error("导出失败");
						}
					};
					reader.readAsText(data);
				} else {
					this.$Message.error((data && data.msg) || "导出失败");
				}
			}
		}
	};
</script>
